import React, { useEffect, useState } from "react";
import Dollies from "../images/home/dollies.png";
import { DolliesNeverDie } from "./ArchivePage";
import BlackFooter from "../components/BlackFooter";
import { BlackRedirectArrow, HomeBoot } from "../components/images";
import Dresses from "../components/dresses";
import PastYears from "../components/years";
import { FutureYears } from "../components/years";
import PhotoAlbum from "../components/HomeAlbum";
import Slideshow from "../components/Slideshow";
import MenuBar from "../components/MenuBar";
import { CloseOutIcon } from "../components/images";
import PageLoader from "../components/PageLoader";

function HomePageMainContents() {
  const [isWideScreen, setIsWideScreen] = useState(window.innerWidth > 1024);
  useEffect(() => {
    const handleResize = () => {
      setIsWideScreen(window.innerWidth > 1024);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <PageLoader>
    <div className="page-container">
      <div className="vertical-box">
        <div className="vertical-box relative">
          <img
            src={Dollies}
            width="100%"
            height="auto"
            alt="Stanford Dollies 25-26"
            className="home"
          />
          <div className="home-header-box center-box">
            <div className="home-header color-white home-layer-up">
              THE STANFORD DOLLIES
            </div>
          </div>
        </div>
        <div className="home-text-box">
          <div className="boot-right absolute">{HomeBoot()}</div>
          <div className="color-light-pink home-background-text">
            THE DOLLIES
          </div>
          <div className="relative home-text-margin">
            <h1 className="color-red home-layer-up relative">
              THE STANFORD DOLLIES ARE A GROUP OF FIVE DANCERS WHO DAZZLE AT
              SPORTING EVENTS AND RALLIES, AS PART OF THE STANFORD BAND.
            </h1>
            <div className="small-bottom-margin" />
            <div className="home-text-margin">
              <p className="color-red">
                Since 1953, The Dollies have won hearts of Stanford fans and
                beyond, with their stunning attire, high energy and winning
                smiles. With each passing year, the five ladies keep history
                alive, performing beloved dances from the past, while also
                contributing their own choreography and creativity. Each Dollie
                brings her own dance experience and background to the group,
                lending styles like ballet, modern, jazz, hip-hop, and more. The
                result is always unique and impressive, laced with the legacy of
                Dollie sisterhood.
              </p>
              <div className="small-bottom-margin" />
              <p className="color-red">
                The doors of dance are wide open for these women, who often go
                on to perform and choreography professionally—but as they all
                say, “Once a Dollie, Always a Dollie!"
              </p>
            </div>
            <div className="medium-bottom-margin" />
            <div className="additional-margin" />
          </div>
        </div>
        <div className="white-triangle" />
        <Dresses />
        <div className="resp-bottom-margin" />
        <div>
          {isWideScreen && (
            <div className="vertical-box center-box scale-down">
              <div className="photo-album-text color-white">PHOTO ALBUM</div>
              <div className="photo-album-subtext color-white">
                Photos from the 1950s to the 2020s. The Dollie Legacy has lasted
                over 70+ years, and continues to live on.{" "}
              </div>
              <PhotoAlbum />
            </div>
          )}
        </div>
        {isWideScreen && <div className="small-bottom-margin" />}
        <DolliesNeverDie />
        <div className="small-bottom-margin" />
        <Slideshow />
        <div className="medium-bottom-margin" />
        <div className="home-text-box">
          <FutureYears />
          <div className="red-triangle" />
          <div className="interested-box-padding center-box">
            <div className="vertical-box">
              <div className="small-bottom-margin" />
              <div className="interested-margin" />
              <h1 className="color-black center-box">INTERESTED?</h1>
              <h1 className="color-black center-box"> YOU COULD BE NEXT!</h1>
              <div className="small-bottom-margin" />
              <div className="center-box">
                <a href="/audition" className="horizontal-box">
                  <h4 className="color-black">Auditions</h4>
                  <div className="mini-left-margin center-box scale-down">
                    {BlackRedirectArrow()}
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <BlackFooter />
      </div>
    </div>
    </PageLoader>
  );
}

function HomePage() {
  const [menu, setMenu] = useState(false);
  const [fadeOutMain, setFadeOutMain] = useState(false);
  const [fadeInMenu, setFadeInMenu] = useState(false);
  const [isWideScreen, setIsWideScreen] = useState(window.innerWidth > 767);
  useEffect(() => {
    const handleResize = () => {
      setIsWideScreen(window.innerWidth > 767);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleMenuOpen = () => {
    setFadeOutMain(true);
    setTimeout(() => {
      setMenu(true);
      setFadeOutMain(false);
      setFadeInMenu(true);
    }, 300);
  };

  const handleMenuClose = () => {
    setFadeInMenu(false);
    setTimeout(() => {
      setMenu(false);
      setFadeOutMain(false);
      setFadeInMenu(false);
    }, 300);
  };

  return (
    <div className="fade-in-content">
      {menu ? (
        <div className={fadeInMenu ? "fade-in-content" : "fade-out-content"}>
          <div>
            <button className="close-out" onClick={handleMenuClose}>
              {CloseOutIcon()}
            </button>
          </div>
          <MenuBar />
        </div>
      ) : (
        <div className={fadeOutMain ? "fade-out-content" : "fade-in-content"}>
          <div className="end-box small-right-margin">
            <button className="end-box" onClick={handleMenuOpen}>
              <p className="color-white mini-top-margin absolute home-layer-up menu">
                MENU
              </p>
            </button>
          </div>
          <HomePageMainContents />
        </div>
      )}
    </div>
  );
}

export default HomePage;
